import { render } from "./ShowLabel.vue?vue&type=template&id=86c60402"
import script from "./ShowLabel.vue?vue&type=script&lang=js"
export * from "./ShowLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__